"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditProfileTagButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var semantic_ui_react_1 = require("semantic-ui-react");
var EditProfileTag_1 = require("./EditProfileTag");
var i18n_1 = __importDefault(require("../i18n"));
var withState_1 = require("../hocs/withState");
exports.EditProfileTagButton = (0, withState_1.withState)()(["editTags", "setEditTags", "lang"]).memoFC(function (state) {
    return state.editTags !== state.user.id &&
        (!state.user.profile || !state.user.profile.lockTags) &&
        Boolean(state.user.profile && state.user.profile.tags && state.user.profile.tags.length > 0) ===
            state.besideTags ? ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Popup, { position: "bottom center", content: i18n_1.default.tagsDescription, trigger: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, { basic: true, type: "button", icon: "tag", size: "mini", onClick: function () {
                state.setEditTags(state.user.id);
                // フォーカスを合わせるためのハック
                setImmediate(function () { return EditProfileTag_1.editProfileTagRef.current && EditProfileTag_1.editProfileTagRef.current.searchRef.focus(); });
            } }) })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}));
});
